import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import DatePickerComponent from "../DatePickerComponent";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { ApiHook } from "../../../hooks/apiHook";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

const AddEventsModal = ({
  leadId,
  showAddLeadModal,
  setShowAddLeadModal,
  editFormData,
  setEditFormData,
  setEventModal,
  setEventFormData,
  eventFormData,
  showEventModal,
  handleInputChange,
  handleSubmit,
  leadList,
  funnalStages,
  onSuccess,
  onFailure,
  setErrorMessage,
  errorMessage,
}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [followDate, setFollowDate] = useState(editFormData?.followupDate);
  const [files, setFiles] = useState([]);
  const [formData, setFormData] = useState({
    description: "",
    followupDate: dayjs().format("YYYY-MM-DD"),
  });

  const handleClose = () => {
    setEventModal(false);
    setEventFormData({
      leadId: "",
      eventName: "",
      eventDescription: "",
      eventDate: "",
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setEventFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrorMessage((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };
  const handleDateChange = (newDate) => {
    if (newDate) {
      const formattedDate = dayjs(newDate).format("YYYY-MM-DD HH:mm:ss");
      setEventFormData((prev) => ({
        ...prev,
        eventDate: newDate,
      }));
      setErrorMessage((prevState) => ({
        ...prevState,
        eventDate: "",
      }));
    }
  };

  return (
    <Modal
      id="addfollowup"
      show={showEventModal}
      onHide={handleClose}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit event</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="form-group">
            <Form.Label>{t("leadName")}</Form.Label>
            <Form.Select
              id="lead"
              name="leadId"
              value={eventFormData?.leadId}
              onChange={(e) => handleChange(e)}
            >
              <option value="">Select Lead</option>
              {leadList?.map((lead, index) => (
                <option value={lead["CrmLeads.id"]} key={index}>
                  {lead["CrmLeads.firstName"] + " " + lead["CrmLeads.lastName"]}
                </option>
              ))}
            </Form.Select>
            {errorMessage.leadId && (
              <span className="validation-error-message">
                This filed is required
              </span>
            )}
          </Form.Group>

          <Form.Group className="form-group">
            <Form.Label>{t("event_type")}</Form.Label>

            <Form.Select
              id="lead"
              name="leadStatus"
              value={eventFormData?.leadStatus}
              onChange={handleChange}
            >
              <option value="">Select Event</option>

              {funnalStages?.length > 0 ? (
                funnalStages
                  .filter((funObj) => funObj.eventStatus) // Ensure correct key
                  .map((funObj) => (
                    <option key={funObj.id} value={funObj.id}>
                      {funObj.name}
                    </option>
                  ))
              ) : (
                <option disabled>No stages available</option>
              )}
            </Form.Select>
            {errorMessage.leadStatus && (
              <span className="validation-error-message">
                This filed is required
              </span>
            )}
          </Form.Group>
          <Form.Group className="form-group">
            <Form.Label>{t("description")}</Form.Label>
            <Form.Control
              id="description"
              as="textarea"
              type="text"
              placeholder=""
              name="eventDescription"
              value={eventFormData?.eventDescription}
              onChange={handleChange}
            />
            {errorMessage.eventDescription && (
              <span className="validation-error-message">
                This filed is required
              </span>
            )}
          </Form.Group>
          <Form.Group className="form-group">
            <Form.Label>{t("eventDate")}</Form.Label>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                className={"form-control"}
                //date={eventFormData?.eventDate}
                value={eventFormData?.eventDate}
                name="eventDate"
                past={true}
                onChange={handleDateChange}
                ampm
              />
            </LocalizationProvider>
            {errorMessage.eventDate && (
              <span className="validation-error-message">
                This filed is required
              </span>
            )}
          </Form.Group>

          <Form.Group className="form-group">
            <Form.Label>{t("eventStatus")}</Form.Label>
            <Form.Select
              id="lead"
              name="eventStatus"
              value={eventFormData?.eventStatus}
              onChange={handleChange}
            >
              <option value="">Select Status</option>
              <option value="0">Pending</option>
              <option value="1">Completed</option>
              <option value="2">Canceled</option>
            </Form.Select>
            {errorMessage.eventStatus && (
              <span className="validation-error-message">
                This filed is required
              </span>
            )}
          </Form.Group>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("close")}
            </Button>
            <Button variant="primary" type="submit">
              {t("addEvent")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddEventsModal;
